import store from '../redux/store';
import moment from 'moment';
import { message } from 'antd';
import sentGAEvent from '@/ga';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import device from 'current-device';
import SparkMD5 from 'spark-md5';
import {
  HitPaw_Home_LinkData,
  HitPaw_OnlineTools_LinkData,
  HitPawToolkit_Buy_LinkData,
  HitPawToolkit_EXE_LinkData,
  HitPawWatermarkRemover_EXE_LinkData,
  HitPawWatermarkRemover_Buy_LinkData,
  HitPaw_WatermarkRemover_Product_LinkData,
  HitPawVideoEditor_EXE_LinkData,
  HitPawVideoEditor_Buy_LinkData,
  HitPawVideoEdito_Product_LinkData,
  HitPaw_Video_Converter,
  HitPaw_Screen_Recorder_LinkData,
  Hitpaw_Cutter_LinkData,
  HitPaw_Privacy_LinkData,
  HitPaw_Service_LinkData,
  HitPawConvertLinkData,
} from './linkData';

const Utils = {
  wss: null,
  cancleProgress: (numer, startTime) => {
    store.dispatch({
      type: 'CANCELPROGRESS_CHANGE',
      cancelProgress: true,
    });
    store.dispatch({
      type: 'PROCESSPERCENT_CHANGE',
      processPercent: 0,
    });
    if (Utils.wss) {
      Utils.wss.close();
    }
    // if (store.getState().work.currProgress) {
    //   const formData = new FormData();
    //   formData.append(
    //     'number',
    //     numer ? numer : store.getState().work.currProgress.number
    //   );
    //   // formData.append("pid", store.getState().work.currProgress.pid);
    //   formData.append('token', store.getState().common.tokenId);
    //   let category, action;
    //   fetch(`${api_config.WS_API_URL}/stopTask`, {
    //     method: 'post',
    //     body: formData,
    //   })
    //     .then((response) => response.json())
    //     .then((responseJSON) => {
    //       if (responseJSON.code === 1) {
    //         if (store.getState().files.currFile) {
    //           switch (store.getState().work.work) {
    //             case 'togif':
    //               startTime = store.getState().work.startTime.gif;
    //               category = 'ToGif';
    //               action = 'ToGifCancel';
    //               break;
    //             default:
    //               startTime = 0;
    //           }
    //           sentGAEvent({
    //             category: category,
    //             action: action,
    //             label: (new Date().getTime() - startTime) / 1000,
    //           });
    //         } else if (
    //           store.getState().work.work === 'convert' &&
    //           store.getState().files.files.length
    //         ) {
    //           sentGAEvent({
    //             category: 'Convert',
    //             action: 'ConvertCancel',
    //             label: (new Date().getTime() - startTime) / 1000,
    //           });
    //         } else {
    //           sentGAEvent({
    //             category: 'Upload',
    //             action: 'LoadCancel',
    //             label:
    //               (new Date().getTime() -
    //                 store.getState().work.startTime.upload) /
    //               1000,
    //           });
    //         }
    //       }
    //     });
    // }
  },
  getHitPawConvertSeoLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;

    return HitPawConvertLinkData[lang]
      ? HitPawConvertLinkData[lang]
      : HitPawConvertLinkData.en;
  },
  getProgress: (number, unChangeProcess, callback, guid, type) => {
    store.dispatch({
      type: 'CURRPROGRESS_CHANGE',
      currProgress: {
        number: number,
      },
    });
    // store.dispatch({
    //   type: 'CANCELPROGRESS_CHANGE',
    //   cancelProgress: false,
    // });
    let percent;
    return new Promise((resolve, reject) => {
      const _getProgress = () => {
        console.log('websocket：进入请求');
        const ws = (Utils.wss = new WebSocket(
          `${api_config.WS_API_URL}/progressbar?authorization=${
            store.getState().common.authorization
          }`
        ));
        ws.onopen = (event) => {
          console.log('websocket：请求websocket');
          ws.send(
            JSON.stringify({
              number,
              token: store.getState().common.tokenId,
              is_info: 1,
              is_thumbnail: 1,
              thumbnail_ext: 'jpg',
              thumbnail_size: '70x40',
              thumbnail_number: type === 'convertImage' ? 1 : 7,
            })
          );
        };
        ws.onmessage = (event) => {
          const data = JSON.parse(event.data);
          console.log(
            'websocket：收到websocket的message',
            store.getState().work.cancelProgress,
            data
          );
          if (data.code !== 200) {
            reject(new Error(data.msg));
            ws.close();
            return false;
          }
          console.log(
            23232323233333333333333333333,
            store.getState().work.cancelProgress
          );
          if (store.getState().work.cancelProgress) {
            reject('cancel');
            ws.close();
            store.dispatch({
              type: 'CANCELPROGRESS_CHANGE',
              cancelProgress: false,
            });
            return false;
          }
          percent = data.data.progress * 1;
          if (data.data.status !== 1 && data.data.status !== 2) {
            console.log('websocket: 进度条不对劲');
            reject(
              percent +
                '_' +
                store.getState().common.tokenId +
                '_' +
                number +
                '_none'
            );
            ws.close();
            return false;
          }
          if (callback) {
            callback(percent, guid);
          } else {
            if (
              store.getState().work.processPercent < 100 &&
              !unChangeProcess
            ) {
              store.dispatch({
                type: 'PROCESSPERCENT_CHANGE',
                processPercent: percent === 0 ? 1 : percent,
              });
            } else if (!unChangeProcess) {
              store.dispatch({
                type: 'PROCESSPERCENT_CHANGE',
                processPercent:
                  percent +
                  (store.getState().work.processPercent -
                    (store.getState().work.processPercent % 100)),
              });
            }
          }

          console.log('websocket: 进度', percent);
          if (percent === 100) {
            console.log('websocket: ====返回信息');

            resolve(data.data);
            ws.close();
          }
        };
        ws.onerror = (event) => {
          reject(
            '-1_' + store.getState().common.tokenId + '_' + number + '_none'
          );
          ws.close();
          // _getProgress()
        };
        ws.onclose = (event) => {
          window.addEventListener('offline', function () {
            reject('offLine');
          });
          console.log('websocket: 关闭');
        };
      };
      _getProgress();
    });
  },

  getDuration: (videofileurl) => {
    console.log('getDuration');
    const formData = new FormData();
    formData.append('url', videofileurl);
    formData.append('token', store.getState().common.tokenId);
    return new Promise((resolve, reject) => {
      fetch(`${api_config.WS_API_URL}/getvideosize`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            reject(
              'getvideosize_' +
                response.status +
                '_none_none_' +
                store.getState().common.tokenId +
                '_none_none'
            );
          }
        })
        .then((responseJSON) => {
          if (responseJSON.code === 1) {
            resolve(responseJSON);
          } else {
            reject(
              'getvideosize_200_' +
                responseJSON.code +
                '_none_' +
                store.getState().common.tokenId +
                '_none_none'
            );
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getScreenshots: (videofileurl, num) => {
    const formData = new FormData();
    formData.append('number', num);
    formData.append('size', '100x40');
    formData.append('ext', 'jpg');
    formData.append('videofileurl', videofileurl);
    formData.append('token', store.getState().common.tokenId);
    return new Promise((resolve, reject) => {
      fetch(`${api_config.WS_API_URL}/videoscreenshot`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            reject(
              'videoscreenshot_' +
                response.status +
                '_none_none_' +
                store.getState().common.tokenId +
                '_none_none'
            );
          }
        })
        .then((responseJSON) => {
          if (responseJSON.code === 1) {
            resolve(responseJSON);
          } else {
            reject(
              'videoscreenshot_200_' +
                responseJSON.code +
                '_' +
                store.getState().common.tokenId +
                '_none_none'
            );
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAudioDuration: (audiofileurl) => {
    const formData = new FormData();
    formData.append('url', audiofileurl);
    formData.append('token', store.getState().common.tokenId);
    return new Promise((resolve, reject) => {
      fetch(`${api_config.WS_API_URL}/getaudioinfo`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            reject(
              'getaudioinfo_' +
                response.status +
                '_none_none_' +
                store.getState().common.tokenId +
                '_none_none'
            );
          }
        })
        .then((responseJSON) => {
          if (responseJSON.code === 1) {
            resolve(responseJSON);
          } else {
            reject(
              'getaudioinfo_200_' +
                responseJSON.code +
                '_' +
                store.getState().common.tokenId +
                '_none_none'
            );
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  downloadFile: (obj, format, nameKey) => {
    message.loading(window.i18n.t('upload:downloading'), 0);
    let url =
      obj.downloadurl || obj.videofileurl || obj.audiofileurl || obj.fileurl;
    let newName = nameKey ? obj[nameKey].split('.')[0] : obj.name.split('.')[0];
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        message.destroy();
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.target = '_blank';
        a.download = `${newName}.${format}`;
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        message.destroy();
        message.destroy();
      });
  },

  urlToBlob: (url) => {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          let blobUrl = window.URL.createObjectURL(blob);
          resolve(blobUrl);
        })
        .catch((error) => {
          reject(error);
          message.error('URL to Blob failed.');
        });
    });
  },

  urlToArrayBuffer: (url) => {
    return new Promise((resolve, reject) => {
      fetch(url, {
        responseType: 'arraybuffer',
      })
        .then((res) => res.arrayBuffer())
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
          message.error('URL To ArrayBuffer failed.');
        });
    });
  },

  downloadBase64: (url) => {
    // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
    if (window.navigator.msSaveOrOpenBlob) {
      var bstr = atob(url.split(',')[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var blob = new Blob([u8arr]);
      window.navigator.msSaveOrOpenBlob(blob, 'HitPaw-screenshot.jpg');
    } else {
      // 这里就按照chrome等新版浏览器来处理
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.setAttribute('download', 'HitPaw-screenshot');
      a.click();
    }
  },

  getBase64: (file) => {
    return new Promise((resolve, reject) => {
      ///FileReader类就是专门用来读文件的
      const reader = new FileReader();
      //开始读文件
      //readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串，
      reader.readAsDataURL(file);
      // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
      reader.onload = () => resolve(reader.result);
      // 失败返回失败的信息
      reader.onerror = (error) => reject(error);
    });
  },
  getWH: (base64) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve({ width: img.width, height: img.height });
      img.src = base64;
      img.onerror = (error) => reject(error);
    });
  },

  handleBlurFormat: (type, list, index, workType) => {
    console.log(list[index]);
    let obj;
    let duration;
    if (workType === 'gif') {
      duration = store.getState().work.toGifObj.duration;
    }
    if (index || index === 0) {
      obj = list[index];
    } else {
      obj = list.filter((item) => item.selected)[0];
    }
    if (
      !/^\d+:\d+\.\d+$/.test(obj.start) ||
      Utils.getSeconds(obj.start) >= Utils.getSeconds(duration) ||
      !moment(obj.start.replace('.', ':'), 'mm:ss:SS').isValid()
    ) {
      obj.start = '00:00.00';
    }
    if (
      !/^\d+:\d+\.\d+$/.test(obj.end) ||
      Utils.getSeconds(obj.end) <= Utils.getSeconds(obj.start) ||
      !moment(obj.end.replace('.', ':'), 'mm:ss:SS').isValid()
    ) {
      obj.end = duration;
    }
    if (
      workType === 'gif' &&
      Utils.getSeconds(obj.end) - Utils.getSeconds(obj.start) > 50
    ) {
      obj.end = moment(obj.start.replace('.', ':'), 'mm:ss:SS')
        .add(50, 'seconds')
        .format('mm:ss:SS')
        .replace(/:([^:]*)$/, '.$1');
    }
    if (Utils.getSeconds(obj.end) - Utils.getSeconds(obj.start) <= 1) {
      obj.end = moment(obj.start.replace('.', ':'), 'mm:ss:SS')
        .add(1, 'seconds')
        .format('mm:ss:SS')
        .replace(/:([^:]*)$/, '.$1');
      if (Utils.getSeconds(obj.end) >= Utils.getSeconds(duration)) {
        console.log('哈哈哈哈哈');
        obj.end = duration;
        obj.start = moment(obj.end.replace('.', ':'), 'mm:ss:SS')
          .subtract(1, 'seconds')
          .format('mm:ss:SS')
          .replace(/:([^:]*)$/, '.$1');
      }
    }

    if (type === 'CURRFILE_CHANGE') {
      store.dispatch({
        type: type,
        currFile: obj,
      });
    } else if (type === 'TOGIFOBJ_CHANGE') {
      store.dispatch({
        type: type,
        toGifObj: obj,
      });
    }
  },

  getSize: (param) => {
    if (param <= 1024 * 1024) {
      return (param / 1024).toFixed(0) + 'KB';
    } else if (param <= 1024 * 1024 * 1024) {
      return (param / 1024 / 1024).toFixed(2) + 'MB';
    }
  },

  getUpdateTime: (param) => {
    const duration = parseInt((new Date().getTime() - param) / 1000);
    if (duration <= 60) {
      return {
        text: 'Just now',
      };
    } else if (duration < 60 * 2) {
      return {
        text: 'minute ago',
        num: 1,
      };
    } else if (duration < 60 * 60) {
      return {
        text: 'minutes ago',
        num: parseInt(duration / 60),
      };
    } else if (duration < 60 * 60 * 2) {
      return {
        text: 'hour ago',
        num: 1,
      };
    } else if (duration <= 60 * 60 * 24) {
      return {
        text: 'hours ago',
        num: parseInt(duration / 60 / 60),
      };
    } else {
      return {
        text: 'day ago',
        num: 1,
      };
    }
  },

  resolution: (width, height, scale) => {
    if (scale * height <= width) {
      return {
        width: parseInt(scale * height),
        height: height,
      };
    } else {
      return {
        width: width,
        height: parseInt(width / scale),
      };
    }
  },

  getSeconds: (obj) => {
    if (obj && moment(obj.replace('.', ':'), 'mm:ss:SS').isValid()) {
      return moment
        .duration(
          moment(obj.replace('.', ':'), 'mm:ss:SS').valueOf() -
            moment('00:00:00', 'mm:ss:SS').valueOf()
        )
        .as('seconds');
    } else {
      return 0;
    }
  },

  getAllSeconds: (arr) => {
    let s = 0;
    arr.forEach((item) => {
      s = s + Utils.getSeconds(item.duration);
    });
    return s;
  },

  handleImgErr: (event, src) => {
    const handleImgErr = [...store.getState().common.handleImgErr];
    if (handleImgErr.filter((item) => item.src === src).length > 0) {
      if (handleImgErr.filter((item) => item.src === src)[0].times >= 5) {
        return false;
      } else {
        handleImgErr.filter((item) => item.src === src)[0].times += 1;
        event.target.src = src;
        store.dispatch({
          type: 'HANDLEIMGERR_CHANGE',
          handleImgErr: handleImgErr,
        });
      }
    } else {
      handleImgErr.push({
        src: src,
        times: 1,
      });
      store.dispatch({
        type: 'HANDLEIMGERR_CHANGE',
        handleImgErr: handleImgErr,
      });
      event.target.src = src;
    }
  },

  validate: (obj, accept) => {
    if (accept && typeof accept === 'string') {
      accept = accept
        .split(',')
        .map((item) =>
          item.replace('.', '').replace(/\s+/g, '').toLocaleUpperCase()
        );
    }
    let result = false;
    if (!accept) {
      accept = [
        'MKV',
        'MOV',
        'MP4',
        'AVI',
        'WMV',
        'VOB',
        'WEBM',
        '3GP',
        'ASF',
        'F4V',
        'FLV',
        'MPG',
        'MPEG',
        'RM',
        'RMVB',
        'MTS',
        'MXF',
        'OGV',
      ];
    }
    accept.forEach((item) => {
      if (
        /\.[^.]+$/
          .exec(obj.name)[0]
          .toLocaleLowerCase()
          .match(item.toLocaleLowerCase()) !== null
      ) {
        result = true;
        // return false;
      }
    });
    if (!result) {
      sentGAEvent({
        category: 'Upload',
        action: 'UnSupportFormat',
        label:
          /\.[^.]+$/.exec(obj.name)[0].toLocaleLowerCase() +
          '_' +
          (obj.size / 1024 / 1024).toFixed(2),
      });
    }
    return result;
  },

  getIndex: (obj, arr) => {
    let index = null;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].guid === obj.guid && arr[i].update === obj.update) {
        index = i;
        break;
      }
    }
    return index;
  },

  delFiles: (files) => {
    const formData = new FormData();
    files.forEach((item) => {
      formData.append('file_url[]', item);
    });
    formData.append('token', store.getState().common.tokenId);
    fetch(`${api_config.WS_API_URL}/delPathFiles`, {
      method: 'post',
      body: formData,
    });
  },

  getBlobDuration: async (blob) => {
    const tempVideoEl = document.createElement('video');
    const durationP = new Promise((resolve, reject) => {
      tempVideoEl.addEventListener('loadedmetadata', () => {
        if (tempVideoEl.duration === Infinity) {
          tempVideoEl.currentTime = Number.MAX_SAFE_INTEGER;
          tempVideoEl.ontimeupdate = () => {
            tempVideoEl.ontimeupdate = null;
            resolve(tempVideoEl.duration);
            tempVideoEl.currentTime = 0;
          };
        } else {
          resolve(tempVideoEl.duration);
        }
      });
      tempVideoEl.addEventListener('error', () => {
        reject(new Error('can load video'));
      });
    });
    tempVideoEl.src =
      typeof blob === 'string' || blob instanceof String
        ? blob
        : window.URL.createObjectURL(blob);
    return durationP;
  },

  blobToImage: async (blob) => {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(blob);
      let img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = () => {
        reject("can't transform to image");
      };
      img.src = url;
    });
  },

  getLanguage: () => {
    let language = document
      .getElementById('hitpaw-online-root')
      .getAttribute('lang');
    // if (language === "ar") {
    //   document.body.parentNode.style = "direction: rtl;";
    // }
    switch (language) {
      case 'in':
        language = 'inn';
        break;
      case 'tk':
        language = 'tr';
      default:
        break;
    }
    return language ? language : 'en';
  },

  // HitPaw Toolkit 购买 链接
  getHitPawToolKitBuyLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPawToolkit_Buy_LinkData[lang][sys]
      ? HitPawToolkit_Buy_LinkData[lang][sys]
      : HitPawToolkit_Buy_LinkData.en[sys];
  },
  //HitPaw Convert
  getHitPawConvertLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPaw_Video_Converter[lang][sys]
      ? HitPaw_Video_Converter[lang][sys]
      : HitPaw_Video_Converter.en[sys];
  },

  // HitPaw Toolkit 安装包 链接
  getHitPawToolKitEXELink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPawToolkit_EXE_LinkData[lang][sys]
      ? HitPawToolkit_EXE_LinkData[lang][sys]
      : HitPawToolkit_EXE_LinkData.en[sys];
  },

  // HitPaw Video Editor 购买 链接
  getHitPawVideoEditorBuyLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPawVideoEditor_Buy_LinkData[lang][sys]
      ? HitPawVideoEditor_Buy_LinkData[lang][sys]
      : HitPawVideoEditor_Buy_LinkData.en[sys];
  },

  getHitPawVideoScreenLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPaw_Screen_Recorder_LinkData[lang][sys]
      ? HitPaw_Screen_Recorder_LinkData[lang][sys]
      : HitPaw_Screen_Recorder_LinkData.en[sys];
  },

  // HitPaw Video Editor 安装包 链接
  getHitPawVideoEditorEXELink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPawVideoEditor_EXE_LinkData[lang][sys]
      ? HitPawVideoEditor_EXE_LinkData[lang][sys]
      : HitPawVideoEditor_EXE_LinkData.en[sys];
  },

  // HitPaw Watermark Remover 购买 链接
  getHitPawWatermarkRemoverBuyLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPawWatermarkRemover_Buy_LinkData[lang][sys]
      ? HitPawWatermarkRemover_Buy_LinkData[lang][sys]
      : HitPawWatermarkRemover_Buy_LinkData.en[sys];
  },

  // HitPaw Watermark Remover 安装包 链接
  getHitPawWatermarkRemoverEXELink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    const sys = window.userClient.platform === 'win' ? 'win' : 'mac';
    return HitPawWatermarkRemover_EXE_LinkData[lang][sys]
      ? HitPawWatermarkRemover_EXE_LinkData[lang][sys]
      : HitPawWatermarkRemover_EXE_LinkData.en[sys];
  },

  // HitPaw 落地页 链接
  getHitPawLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    return HitPaw_OnlineTools_LinkData[lang]
      ? HitPaw_OnlineTools_LinkData[lang]
      : HitPaw_OnlineTools_LinkData.en;
  },

  // HitPaw 首页 链接
  getHitPawHomeLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    return HitPaw_Home_LinkData[lang]
      ? HitPaw_Home_LinkData[lang]
      : HitPaw_Home_LinkData.en;
  },

  // HitPaw 去水印产品 链接
  getHitPawWatermarkRemoverPageLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    return HitPaw_WatermarkRemover_Product_LinkData[lang]
      ? HitPaw_WatermarkRemover_Product_LinkData[lang]
      : HitPaw_WatermarkRemover_Product_LinkData.en;
  },

  // HitPaw 去水印产品 链接
  getHitPawVideoEditorPageLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    return HitPawVideoEdito_Product_LinkData[lang]
      ? HitPawVideoEdito_Product_LinkData[lang]
      : HitPawVideoEdito_Product_LinkData.en;
  },
  getHitPawCutterLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    return Hitpaw_Cutter_LinkData[lang]
      ? Hitpaw_Cutter_LinkData[lang]
      : Hitpaw_Cutter_LinkData.en;
  },
  isImageLoadedSuccess: async (list, key, callback) => {
    console.log(list);
    let i = 0;
    const _load = async () => {
      if (list[i].audiofileurl) {
        if (i < list.length - 1) {
          i++;
          _load();
        }
        return false;
      }
      let loaded = await new Promise((resolve) => {
        const img = new Image();
        img.onerror = (error) => {
          message.warn(
            window.i18n.t(
              'common:The thumbnail is missing, but you can download and continue editing videos normally. If you feel troubled, please download the video first and then upload it again.'
            ),
            7
          );
          console.log('图片请求失败');
          resolve(false);
          callback('0');
        };
        img.onload = () => {
          resolve(true);
          if (
            i ===
            list.length - list.filter((item) => item.audiofileurl).length - 1
          ) {
            console.log('图片全部请求完成');
            callback('1');
          }
        };
        img.src = list[i][key];
      });
      if (loaded && i < list.length - 1) {
        i++;
        _load();
      }
    };
    _load();
  },

  screenshots: (videoDOM) => {
    try {
      const video = document.querySelector('#videoRef video');
      const canvas = document.querySelector('#canvas');
      const context = canvas.getContext('2d');
      const w = video.videoWidth;
      const h = video.videoHeight;
      canvas.width = w;
      canvas.height = h;
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL('image/jpg');
      Utils.downloadBase64(dataUrl);
      message.success('已截图并下载');
    } catch (err) {
      console.log(err);
      message.warn('截图失败');
    }
  },

  omissionString: (str, preLength, nextLength) => {
    if (str && str.length > preLength + nextLength) {
      let subStr1 = str.substr(0, preLength);
      let subStr2 = str.substr(str.length - nextLength, nextLength);
      let subStr = subStr1 + '...' + subStr2;
      return subStr;
    }
    return str;
  },

  fileToBlob: async (file, isScreenshots) => {
    let blob;
    try {
      blob = new Blob([file], {
        type: file.type,
      });
    } catch (err) {
      console.log('Turn Blob Error: ', err);
      return false;
    }
    const blobUrl = URL.createObjectURL(blob);
    let blobDuration;
    let duration;
    let screenshots = [];
    let thumbnail;
    if (
      file.type.indexOf('video') !== -1 ||
      file.type.indexOf('audio') !== -1
    ) {
      try {
        blobDuration = await Utils.getBlobDuration(blobUrl);
      } catch (error) {
        console.log('blobDuration Err:', error);
        return false;
      }
      duration = moment('00:00.00', 'mm:ss.SS')
        .add(blobDuration.toFixed(2), 'seconds')
        .format('mm:ss.SS');
    }
    if (isScreenshots) {
      //screenshots
      const shot = blobDuration / 7;
      for (let i = 0; i < 7; i++) {
        screenshots.push(blobUrl + '#t=' + i * shot);
      }
      thumbnail = blobUrl + '#t=0';
    }
    const blobObj = {
      duration: duration,
      thumbnail: isScreenshots ? thumbnail : undefined,
      blobUrl: blobUrl,
      screenshots: isScreenshots ? screenshots : undefined,
    };

    return blobObj;
  },
  changeTimeToGAString: (seconds) => {
    if (seconds / 60 < 1) {
      return '<1min';
    } else if (seconds / 60 > 3) {
      return '>3min';
    } else {
      return '1-3min';
    }
  },

  cancelRequsetProcess: (cancelProcessCallBack, uploadNumber) => {
    if (
      store.getState().files.currFile &&
      store.getState().work.fileToBlobStatus &&
      store.getState().work.uploading
    ) {
      this.props.onSubmittingChange(false);
      store.dispatch({
        type: 'SUBMITTING_CHANGE',
        submitting: false,
      });
      return false;
    }
    store.dispatch({
      type: 'SUBMITTING_CHANGE',
      submitting: false,
    });
    store.dispatch({
      type: 'UPLOADING_CHANGE',
      uploading: false,
    });
    store.dispatch({
      type: 'UPLOADPERCENT_CHANGE',
      uploadPercent: 0,
    });
    store.dispatch({
      type: 'PROCESSPERCENT_CHANGE',
      processPercent: 0,
    });
    store.dispatch({
      type: 'UPLOADXHR_CHANGE',
      uploadXHR: null,
    });
    const xhr = store.getState().work.uploadXHR;
    if (
      xhr &&
      store.getState().work.uploadPercent <
        (uploadNumber ? uploadNumber * 100 : 100)
    ) {
      xhr.abort();
    } else {
      if (store.getState().work.fetchAbort) {
        store.getState().work.fetchAbort();
      }
      Utils.cancleProgress();
    }
    if (cancelProcessCallBack) {
      cancelProcessCallBack();
    }
  },

  isVideoBlobURLLoadedSuccess: async (blobUrl) => {
    console.log('哈哈哈');
    return new Promise((resolve, reject) => {
      const videoCont = document.createElement('video');
      videoCont.setAttribute('src', blobUrl);
      videoCont.load();
      videoCont.addEventListener('loadedmetadata', () => {
        if (videoCont.videoWidth && videoCont.videoHeight) {
          resolve(true);
        } else {
          reject(false);
        }
      });
    });
  },

  getFileName: (name) => {
    return name.substring(0, name.lastIndexOf('.'));
  },

  /**
   * 当用户没有登录，或者用户当前不是会员的时候，购买弹窗的判定条件
   * @returns 是否需要弹出购买弹窗
   */
  isNeedToShowPurchaseModal: () => {
    if (
      !store.getState().common.profileObj ||
      !store.getState().common.subscription ||
      (store.getState().common.subscription &&
        store.getState().common.subscription[0].status !== 'Active')
    ) {
      return true;
    }
    return false;
  },
  // convert不走6次判断
  handleConvertVideoEditor: () => {
    Cookies.set(
      'videoEditorTimes',
      store.getState().common.videoEditorTimes + 1,
      {
        expires: 1,
        domain: api_domain_config.DOMAIN,
      }
    );
    store.dispatch({
      type: 'VIDEOEDITORTIMES_CHANGE',
      videoEditorTimes: store.getState().common.videoEditorTimes + 1,
    });
    return false;
  },
  /**
   * 判断游客用户是否超过了6次的操作记录，超出则直接弹出购买窗口
   * @returns true 直接跳出提交 | false 继续执行
   */
  handleVideoEditorTimes: (gaName) => {
    if (store.getState().common.videoEditorTimes >= 6) {
      console.log('游客超过了限制');
      if (gaName) {
        sentGAEvent({
          category: 'UpgradePrompShow',
          action: gaName + '_UpgradePrompShow',
          label: 'Null',
        });
      }
      if (Utils.isNeedToShowPurchaseModal()) {
        store.dispatch({
          type: 'PURCHASEMODALOBJ_CHANGE',
          purchaseModalObj: {
            visible: true,
            type: 'videoEditorTimesMoreThanLimit',
            trigger: '6TrialOver',
          },
        });
        return true;
      }
    } else {
      Cookies.set(
        'videoEditorTimes',
        store.getState().common.videoEditorTimes + 1,
        {
          expires: 1,
          domain: api_domain_config.DOMAIN,
        }
      );
      store.dispatch({
        type: 'VIDEOEDITORTIMES_CHANGE',
        videoEditorTimes: store.getState().common.videoEditorTimes + 1,
      });
    }
    return false;
  },
  /**
   *
   * @param {*} pageType
   * @returns
   */
  getSystemType: () => {
    if (device.desktop()) {
      if (navigator.userAgent.indexOf('Windows') !== -1) {
        //是否Windows
        return 'Windows';
      } else if (navigator.userAgent.indexOf('Mac') !== -1) {
        //是否MAC
        return 'Mac';
      }
    } else {
      return 'other';
    }
  },

  // 系统检测
  systemCheck: () => {
    // {mac:'Mac',win:'Win',ios:'iOS',android:'Android',other:'Other'}
    if (device.ios()) {
      //是否IOS
      return 'iOS';
    } else if (device.android()) {
      //是否安卓
      return 'Android';
    } else if (device.desktop()) {
      if (navigator.userAgent.indexOf('Windows') !== -1) {
        return 'Win';
      } else if (navigator.userAgent.indexOf('Mac') !== -1) {
        //是否MAC
        return 'Mac';
      } else {
        return 'Other';
      }
    } else {
      return 'Other';
    }
  },
  computedSubscribe: (reducerData) => {
    if (reducerData.subscription == null) {
      return false;
    } else {
      if (reducerData.subscription[0].status === 'Active') {
        return true;
      } else {
        return false;
      }
    }
  },
  /**
   * 判断游客用户是否超过了1次的操作图片去除背景记录，超出则直接弹出购买窗口
   * @returns true 直接跳出提交 | false 继续执行
   */
  handleImageCutoutTimes: (pageType) => {
    console.log(pageType);
    if (store.getState().common.imageCutoutTimes >= 1) {
      console.log('游客超过了限制');
      if (Utils.isNeedToShowPurchaseModal()) {
        sentGAEvent({
          category: 'UpgradePrompShow',
          action: '07BC_UpgradePrompShow',
          label: 'Null',
        });
        store.dispatch({
          type: 'PURCHASEMODALOBJ_CHANGE',
          purchaseModalObj: {
            visible: true,
            type:
              pageType === 'BGChanger'
                ? 'imageBGChanerTimesMoreThanLimit'
                : 'imageCutoutTimesMoreThanLimit',
          },
        });
        return true;
      }
    } else {
      Cookies.set(
        'imageCutoutTimes',
        store.getState().common.imageCutoutTimes + 1,
        {
          expires: 1,
          domain: api_domain_config.DOMAIN,
        }
      );
      store.dispatch({
        type: 'IMAGECUTOUTTIMES_CHANGE',
        imageCutoutTimes: store.getState().common.imageCutoutTimes + 1,
      });
    }
    return false;
  },
  getHitPawServiceLink: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    return HitPaw_Service_LinkData[lang]
      ? HitPaw_Service_LinkData[lang]
      : HitPaw_Service_LinkData.en;
  },
  //privacy
  getHitPawPrivacy: () => {
    let lang = Utils.getLanguage();
    lang = lang === 'in' ? 'inn' : lang;
    return HitPaw_Privacy_LinkData[lang]
      ? HitPaw_Privacy_LinkData[lang]
      : HitPaw_Privacy_LinkData.en;
  },
  formatSeconds: (value) => {
    let secondTime = parseInt(value);
    let minuteTime = 0;
    let hourTime = 0;
    if (secondTime >= 60) {
      minuteTime = parseInt(secondTime / 60);
      secondTime = parseInt(secondTime % 60);
      if (minuteTime >= 60) {
        hourTime = parseInt(minuteTime / 60);
        minuteTime = parseInt(minuteTime % 60);
      }
    }
    // 补0
    hourTime = hourTime < 10 ? '0' + hourTime : hourTime;
    minuteTime = minuteTime < 10 ? '0' + minuteTime : minuteTime;
    secondTime = secondTime < 10 ? '0' + secondTime : secondTime;
    let res;
    if (value >= 3600) {
      res = hourTime + ':' + minuteTime + ':' + secondTime;
    } else {
      res = minuteTime + ':' + secondTime;
    }
    return res;
  },

  // 功能模块根节点变化监听
  // 用于seo页会有切换显示隐藏的情况
  observerRootDOM: (callback) => {
    const observer = new MutationObserver(callback);
    const onlineRoot = document.querySelector('#hitpaw-online-root');
    const options = {
      attributes: true,
    };
    observer.observe(onlineRoot, options);
  },
  // 改变头部文字样式
  // 有黑白两种，根据功能块背景色设定
  setHeaderStyle: () => {
    const navbar = document.querySelector('.navbar');
    const className = navbar.className;
    console.log('className', className);
    // 如果是浅色主题，换成深色
    if (className.includes('navbar-light')) {
      navbar.className = className.replace('navbar-light', 'navbar-dark');
    }
    // 此处可用于添加其他逻辑
  },
  /*
   * @param {uploadFile} file 要读的文件
   * @param {number} [chunkSize=1024 * 1024*50]  需要分片的文件大小
   * @return {*}
   */
  fileMd5Func: (file, chunkSize = 1024 * 1024 * 50) => {
    return new Promise((resolve, reject) => {
      if (file.size < chunkSize) {
        // 不需要分片
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(
          file.raw && file.raw.size ? file.raw : file
        );
        fileReader.onload = (e) => {
          let md5 = SparkMD5.hashBinary(e.target.result);
          localStorage.setItem('md5', md5);
          resolve(md5);
          // console.log("不分片md5", md5);
        };
      } else {
        // 需要分片
        let chunks = Math.ceil(
            (file.raw && file.raw.size ? file.raw.size : file.size) / chunkSize
          ),
          currentChunk = 0,
          spark = new SparkMD5.ArrayBuffer(),
          fileReader = new FileReader();
        fileReader.onload = (e) => {
          spark.append(e.target?.result);
          currentChunk++;

          if (chunks && currentChunk < chunks) {
            // console.log(`第${currentChunk}分片解析完成, 开始第${currentChunk + 1} / ${chunks}分片解析`);
            loadNext();
          } else {
            let md5 = spark.end();
            localStorage.setItem('md5', md5);
            resolve(md5);
            // console.log("分片md5", md5);
          }
        };
        const loadNext = () => {
          const size = file.raw && file.raw.size ? file.raw.size : file.size;
          let start = currentChunk * chunkSize,
            end = start + chunkSize >= size ? size : start + chunkSize;
          const fileObj = file.raw && file.raw.size ? file.raw : file;
          fileReader.readAsArrayBuffer(fileObj.slice(start, end));
        };
        loadNext();
      }
    });
  },
  getGaAction: (work) => {
    switch (work) {
      case 'imageCutout':
        return '07BC_BuyClick';
      case 'audioExtractor':
        return '26AE_BuyClick';
      case 'audioJoiner':
        return '27AM_BuyClick';
      case 'videoCompress':
        return '24VC_BuyClick';
      case 'addLipShape':
        return '23FA_BuyClick';
      case 'audioVolume':
        return '30ACV_BuyClick';
      case 'audioAddMusic':
        return '33AM_BuyClick';
      case 'videoMute':
        return '25VM_BuyClick';
      case 'dynamicPhoto':
        return '22AO_BuyClick';
      case 'audioSpeed':
        return '31ACS_BuyClick';
      case 'audioCut':
        return '32AC_BuyClick';
      case 'audioCompress':
        return '28AC_BuyClick';
      case 'togif':
        return '37TG_BuyClick';
      default:
        return undefined;
    }
  },
  gaUpgradePromptShow: (work) => {
    switch (work) {
      case 'addLipShape':
        return '23FA_UpgradePrompShow';
      case 'audioExtractor':
        return '26AE_UpgradePrompShow';
      case 'audioJoiner':
        return '27AM_UpgradePrompShow';
      case 'videoCompress':
        return '24VC_UpgradePrompShow';
      case 'imageCutout':
        return '07BC_UpgradePrompShow';
      case 'audioVolume':
        return '30ACV_UpgradePrompShow';
      case 'audioSpeed':
        return '31ACS_UpgradePrompShow';
      case 'audioCut':
        return '32AC_UpgradePrompShow';
      case 'audioAddMusic':
        return '33AM_UpgradePrompShow';
      case 'videoMute':
        return '25VM_UpgradePrompShow';
      case 'dynamicPhoto':
        return '22AO_UpgradePrompShow';
      case 'audioCompress':
        return '28AC_UpgradePrompShow';
      case 'togif':
        return '37TG_UpgradePrompShow';
      default:
        return undefined;
    }
  },
  getGaBuyNow: (work) => {
    switch (work) {
      case 'imageCutout':
        return '07BC_BuyNow';
      case 'audioExtractor':
        return '26AE_BuyNow';
      case 'audioJoiner':
        return '27AM_BuyNow';
      case 'videoCompress':
        return '24VC_BuyNow';
      case 'addLipShape':
        return '23FA_BuyNow';
      case 'audioVolume':
        return '30ACV_BuyNow';
      case 'audioAddMusic':
        return '33AM_BuyNow';
      case 'videoMute':
        return '25VM_BuyNow';
      case 'dynamicPhoto':
        return '22AO_BuyNow';
      case 'audioSpeed':
        return '31ACS_BuyNow';
      case 'audioCut':
        return '32AC_BuyNow';
      case 'audioCompress':
        return '28AC_BuyNow';
      case 'togif':
        return '37TG_BuyNow';
      default:
        return undefined;
    }
  },
};

export default Utils;
